import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Text from '../Text';

import { DealerCont, LeftSide, RightSide, Content, Award } from './styles';

class DealerContainer extends Component {
  static propTypes = {
    city: PropTypes.string.isRequired,
    dealer: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    addressLine1: PropTypes.string.isRequired,
    addressLine2: PropTypes.string,
    addressLine3: PropTypes.string.isRequired,
    award: PropTypes.bool,
    awardImage: PropTypes.string,
    dealerWebsite: PropTypes.string,
    dealerSEOName: PropTypes.string,
    cityUrl: PropTypes.string,
    stateURL: PropTypes.string,
    // Pass button/anything else that shows up on the right side
    children: PropTypes.node
  };

  static defaultProps = {
    addressLine2: null,
    award: false,
    awardImage: ''
  };

  dealerDetails(dealerName){
    let dealerDtm = {
      name: dealerName,
      action: 'dealer-name'
    }
    if (typeof _satellite !== 'undefined') {
      window.dtmTrackingDataLayer.event.interaction = dealerDtm;
      _satellite.track('dtmInteraction');
    }
  }

  render() {
    const { city, dealer, phone, children, addressLine1, addressLine2, addressLine3, award, awardImage , dealerSEOName,stateURL,cityUrl} = this.props;

    return (
      <DealerCont>
        <LeftSide>
          <Text.H2 color="grey2" transform="uppercase">
            {city}
          </Text.H2>
          <Content>
            <Link to={`/${stateURL}/${cityUrl}/${dealerSEOName}/`} onClick={()=>this.dealerDetails(dealer)} style={{textDecoration: 'underline', textDecorationColor: 'black'}}>
              <Text.H3 transform="uppercase">{dealer}</Text.H3>
            </Link>
            <a href={`tel:+${phone.replace(/-/g, '')}`} dtm-track="dealer-call" dtm-track-button-type="link">
              <Text.Body>
                <Text.Body tag="span" font="icon">
                  {' '}
                </Text.Body>
                <Text.Body tag="span" decoration="underline">
                  {phone}
                </Text.Body>
              </Text.Body>
            </a>
            <Text.Body transform="uppercase" margins={false}>
              {addressLine1}
            </Text.Body>
            {addressLine2 && (
              <Text.Body transform="uppercase" margins={false}>
                {addressLine2}
              </Text.Body>
            )}
            <Text.Body transform="uppercase" margins={false}>
              {addressLine3}
            </Text.Body>
          </Content>
          <Award>{award && <img src="https://www.nissanusa.com/content/dam/Nissan/us/assets/dealers/nissan-aoe-2021.png" style={{height:"35px", paddingTop:"10px"}} alt="Excellence Award" />}</Award>
        </LeftSide>
        <RightSide>{children}</RightSide>
      </DealerCont>
    );
  }
}

export default DealerContainer;
